export default __webpack_public_path__ + "static/media/bosch-logo-simple2.21a3ee95.svg";